module.exports = __webpack_public_path__ + "static/media/PLAY_MACHINES_1.8169b06a.jpg";